import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetJObofferCall,
  SetJObofferCallAction,
  SetActiveTabs,
  SetJObofferDITCallAction,
  setTherossSalaryCreateActions,
  setTherossSalaryActions,
  setClientBranchActions, ///----Client----Branch
  setZoneActions,
  getRoleListActions, ////---role---
  setTheGrossSalarayAmount, ///---gross---salary----amount--hold
  setClientBranchesRetrieveActions,
  setRoleRetrieveActions,
  SetIdVeriications,
  setPreviousDataFetchActions,
  setClientBranchSearchAction,
  settheJobinfoBranchEmployeeProfile,
  setthejobinformationroleID,
  SettheBracnhId,
} from "../../../Redux/Slice";
import { NumericFormat } from "react-number-format";
import useDebouncedEffect from "use-debounced-effect";
import Select from "react-select";
import { unescape } from "lodash";

const Joboffer = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [branchoptions, setbranchoptions] = useState(); //----
  const [roleoptionsList, setROleoptionsList] = useState(); ///--role---
  const [addbasic, setthebasic] = useState(false);
  var CheckBoxfile = addbasic;
  var IDS = "";
  ///--Searchc----
  const initialStateSearch = {
    BranchSearch: "",
    roleSearch: "",
  };
  var timeid;

  const [ErrorInde, setErrInde] = useState(0);
  useEffect(() => {
    timeid = state.BasicFormCreated.BasciFormCreate;
  }, [state.BasicFormCreated.BasciFormCreate]);

  const [SearchedVal, setSearched] = useState(initialStateSearch);
  var roleIDs = ""; ///---role----id----
  const initialState = {
    job_title: "",
    department:
      state.BranchRetrieve.BranchesRetrieve.wbs_element != "" &&
      state.BranchRetrieve.BranchesRetrieve.wbs_element != null
        ? state.BranchRetrieve.BranchesRetrieve.wbs_element
        : "",
    designation: state.NumberCounts.RoleOjects.value,
    //  gross_salary:  state.roleRetrieve.RoleRetrieve.salary != "" &&  state.roleRetrieve.RoleRetrieve.salary != null ?  state.roleRetrieve.RoleRetrieve.salary : "",
    gross_salary: Number(),
    //  timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
    timeline_id: timeid,
    // designation_id: state.NumberCounts.RoleOjects.value,
    designation_id: state.NumberCounts.RoleOjects.value,
    client_id: state.NumberCounts.BranchObjectJobInfoFieldAgent?.value,
    // from_salary,to_salary

    other_allowances_salary: Number(),
    net_salary: Number(),
    hra_salary: Number(),
    employee_PF: Number(),
    employee_ESI: Number(),
    airtime_allowance: Number(),
    basic_salary: Number(),
  };
  const [data, setData] = useState(initialState);

  const [uniforms, setUniforms] = useState({
    shirt_size: null,
    pant_size: null,
    shoe_size: null,
    apron_size: null,
    top_size: null,

    salwar_size: null,
    t_shirt_size: null,
    chef_coat_size: null,
    dupatta_size: null,
    saree_size: null,
    rain_coat_size: null,
    safari_size: null,
    cargo_pant_size: null,
    boots_size: null,
    cap_count: null,
    belt_count: null,
    lanyard_count: null,
    whishel_count: null,
    umbrella_count: null,
    torch_light_count: null,
    traffic_control_torch_light_count: null,
  });
  const [selectedUniforms, setSelectedUniforms] = useState([]);
  const [selectedUniformsError, setSelectedUniformsError] = useState("");
  const [uniformErrors, setUniformErrors] = useState({});
  const uniformKeys = [
    "shirt_size",
    "pant_size",
    "shoe_size",
    "apron_size",
    "top_size",
    "salwar_size",
    "t_shirt_size",
    "chef_coat_size",
    "dupatta_size",
    "saree_size",
    "rain_coat_size",
    "safari_size",
    "cargo_pant_size",
    "boots_size",
    "cap_count",
    "belt_count",
    "lanyard_count",
    "whishel_count",
    "umbrella_count",
    "torch_light_count",
    "traffic_control_torch_light_count",
  ];

  // all available items to choose
  const uniformOptions = [
    { value: "shirt_size", label: "Shirt size" },
    { value: "pant_size", label: "Pant size" },
    { value: "shoe_size", label: "Shoe size" },
    { value: "apron_size", label: "Apron size" },
    { value: "top_size", label: "Top size" },
    { value: "salwar_size", label: "Salwar size" },
    { value: "t_shirt_size", label: "T-Shirt size" },
    { value: "chef_coat_size", label: "Chef coat size" },
    { value: "dupatta_size", label: "Dupatta size" },
    { value: "saree_size", label: "Saree size" },
    { value: "rain_coat_size", label: "Rain coat size" },
    { value: "safari_size", label: "Safari size" },
    { value: "cargo_pant_size", label: "Cargo pant size" },
    { value: "boots_size", label: "Boots size" },

    { value: "cap_count", label: "Cap count" },
    { value: "belt_count", label: "Belt count" },
    { value: "lanyard_count", label: "Lanyard count" },
    { value: "whishel_count", label: "Whistle count" },
    { value: "umbrella_count", label: "Umbrella count" },
    { value: "torch_light_count", label: "Torch light count" },
    {
      value: "traffic_control_torch_light_count",
      label: "Traffic control torch light count",
    },
  ];

  // config for how to render each field
  const uniformConfig = {
    // sizes
    shirt_size: {
      type: "size",
      label: "Shirt size",
      optionsKey: "shirt_size",
    },
    pant_size: {
      type: "size",
      label: "Pant size",
      optionsKey: "pant_size",
    },
    shoe_size: {
      type: "size",
      label: "Shoe size",
      optionsKey: "shoe_size",
    },
    apron_size: {
      type: "size",
      label: "Apron size",
      optionsKey: "apron_size",
    },
    top_size: {
      type: "size",
      label: "Top size",
      optionsKey: "top_size",
    },
    salwar_size: {
      type: "size",
      label: "Salwar size",
      optionsKey: "salwar_size",
    },
    t_shirt_size: {
      type: "size",
      label: "T-Shirt size",
      optionsKey: "t_shirt_size",
    },
    chef_coat_size: {
      type: "size",
      label: "Chef coat size",
      optionsKey: "chef_coat_size",
    },
    dupatta_size: {
      type: "size",
      label: "Dupatta size",
      optionsKey: "dupatta_size",
    },
    saree_size: {
      type: "size",
      label: "Saree size",
      optionsKey: "saree_size",
    },
    rain_coat_size: {
      type: "size",
      label: "Rain coat size",
      optionsKey: "rain_coat_size",
    },
    safari_size: {
      type: "size",
      label: "Safari size",
      optionsKey: "safari_size",
    },
    cargo_pant_size: {
      type: "size",
      label: "Cargo pant size",
      optionsKey: "cargo_pant_size",
    },
    boots_size: {
      type: "size",
      label: "Boots size",
      optionsKey: "boots_size",
    },

    // counts
    cap_count: { type: "count", label: "Cap count" },
    belt_count: { type: "count", label: "Belt count" },
    lanyard_count: { type: "count", label: "Lanyard count" },
    whishel_count: { type: "count", label: "Whistle count" },
    umbrella_count: { type: "count", label: "Umbrella count" },
    torch_light_count: { type: "count", label: "Torch light count" },
    traffic_control_torch_light_count: {
      type: "count",
      label: "Traffic control torch light count",
    },
  };

  const isDisabled =
    state.NumberCounts.Editable == 1
      ? state.ClientBranchIDs.SUBROLE == 3
        ? false
        : true // allow only when SUBROLE = 3
      : state.NumberCounts.Editable == 2
        ? state.NumberCounts.EmployeeFormFIll == true
          ? false
          : true // disable when true
        : null;

  const baseShirtSizes = [
    { label: "S", value: "S" },
    { label: "M", value: "M" },
    { label: "L", value: "L" },
    { label: "XL", value: "XL" },
    { label: "XXL", value: "XXL" },
    { label: "XXXL", value: "XXXL" },
  ];
  const basePantSizes = [
    { label: "28", value: "28" },
    { label: "30", value: "30" },
    { label: "32", value: "32" },
    { label: "34", value: "34" },
    { label: "36", value: "36" },
    { label: "38", value: "38" },
    { label: "40", value: "40" },
    { label: "42", value: "42" },
    { label: "44", value: "44" },
    { label: "46", value: "46" },
  ];

  const baseShoeSizes = [
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
  ];

  const sizes = {
    // tops: use shirt-size list
    shirt_size: baseShirtSizes,
    t_shirt_size: baseShirtSizes,
    chef_coat_size: baseShirtSizes,
    apron_size: baseShirtSizes,
    salwar_size: baseShirtSizes, // female salwar column is same sizes
    dupatta_size: baseShirtSizes,
    saree_size: baseShirtSizes,
    top_size: baseShirtSizes,
    rain_coat_size: baseShirtSizes,
    safari_size: baseShirtSizes,

    // bottoms: use pant-size list
    pant_size: basePantSizes,
    cargo_pant_size: basePantSizes,

    // footwear: use shoe-size list
    shoe_size: baseShoeSizes,
    boots_size: baseShoeSizes, // security shoe
  };

  const [jobtotitleErr, setTitelErr] = useState("");
  const [departmentErr, sedepartmentErr] = useState("");
  const [designationerr, setdesginationErr] = useState("");
  const [grossSalaryErr, setGrossError] = useState("");
  const [branchvalue, SteBranchValue] = useState();
  const [RoleValue, setRoleValue] = useState();
  const [siteObjectVal, setSiteObjectVal] = useState();
  const [siteIDs, setSiteIDS] = useState();
  const [retrievedid, setRetrveeId] = useState();
  console.log(data, "asdajsdn");
  //  const [Validation , setValidated] = useState(0)
  ////---Get--sub role--
  const UserData = useSelector((state) => state.users.UserData);
  const [SubRoleList, setSubRoleList] = useState();
  const [nameList4, setOptions4] = useState([]);
  const [SearchBranch, setSearchBranch] = useState();
  const [branchMantory, setbranchMantory] = useState("");
  const [basicErro, setBasicErr] = useState("");
  const [hraerr, setHraErr] = useState("");
  const [otherErr, setOtherErr] = useState("");
  const [pferr, setPFerr] = useState("");
  const [ESIErr, setESIerr] = useState("");
  const [AirTimeErr, setAirTimeAllo] = useState("");
  const [netslaraer, setNetSalarErr] = useState("");
  const [ZoneSearch, setZoneSearch] = useState("");

  const initialDebouanceSearch = {
    Zonesearch: "",
    roleSearch: "",
    Clientsearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  // useEffect(() => {
  //   if (
  //     // state.FormsIDList.Job_offer_id == "" &&
  //     // state.NumberCounts.EmployeeRoleId != "" &&
  //     data.designation_id != ""&&
  //     state.FormsIDList.ActiveTabs == 10
  //   ) {
  //     const payload = {
  //       // EditID: state.NumberCounts.EmployeeRoleId,
  //       EditID:data.designation_id
  //     };
  //     ///   console.log(state.roleRetrieve.RoleRetrieve  ,"afsd");
  //     dispatch(setRoleRetrieveActions(payload));

  //   }
  // }, [
  //   // state.NumberCounts.EmployeeRoleId,
  //    state.FormsIDList.ActiveTabs == 10,
  //   data.designation_id]);

  const handleSelectChange_selected = (field, selectedOption) => {
    setUniforms((prev) => ({
      ...prev,
      [field]: selectedOption ? selectedOption.value : "",
    }));
    setUniformErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleInputChange = (field, value) => {
    setUniforms((prev) => ({
      ...prev,
      [field]: value,
    }));
    setUniformErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  console.log(uniforms, "sapidpoasid selectedUniforms", selectedUniforms);

  useEffect(() => {
    if (
      state.NumberCounts.branchId != undefined &&
      state.FormsIDList.Job_offer_id == "" &&
      state.FormsIDList.ActiveTabs == 10
    ) {
      const payload = {
        EditId: state.NumberCounts.branchId,
      };
      dispatch(setClientBranchesRetrieveActions(payload));
    }
  }, [state.NumberCounts.branchId, state.FormsIDList.ActiveTabs]);

  // console.log(state.BranchRetrieve.BranchesRetrieve.wbs_element, "BranchesRetrieve",       state.roleRetrieve.RoleRetrieve);

  // function calculateSalary() {
  //   const { wages, salary } = state.roleRetrieve.RoleRetrieve;

  //   if (wages === 1) {
  //     // Calculate weekly salary (assuming 4 weeks in a month)
  //     const weeklySalary = salary / 4;
  //     return weeklySalary;
  //   } else if (wages === 0) {
  //     // Calculate daily salary (assuming 20 working days in a month)
  //     const dailySalary = salary / 20;
  //     return dailySalary;
  //   } else {
  //     // Handle other cases or invalid values for wages
  //     return 0; // Default to 0 or handle error as needed
  //   }
  // }

  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 10 &&
      data.job_title != "" &&
      data.job_title != undefined
    ) {
      const payload = {
        search: SearchBranch,
        page_size: "",
        page: 1,
        data: { state: "", region: "", zone: data.job_title },
        is_reliever: "false",
      };
      if (
        state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
        state?.SideBarFiles?.UserEmailID == "admin@qpms.in"
      ) {
        delete payload.is_reliever;
      }

      dispatch(setClientBranchSearchAction(payload));
    }
  }, [data.job_title, state.FormsIDList.ActiveTabs, SearchBranch]);
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearchBranch(SearchDebounance.Clientsearch);
        setZoneSearch(SearchDebounance.Zonesearch);
        setSearched({
          ...SearchedVal,
          roleSearch: SearchDebounance.roleSearch,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  const HandleInputBranch = (e) => {
    // setSearchBranch(e);
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
            ? `${element.branch_code}-${element.client_name.toUpperCase()}`
            : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, SearchBranch]);
  useEffect(() => {
    if (state.users.UserData.data != undefined) {
    }
    if (UserData.session) {
      // console.log(UserData.data.sub_role, "UserDsdsdasdata");
      if (UserData.data != undefined && UserData.data != null) {
        setSubRoleList(UserData.data.sub_role);
      }
    }
  }, [UserData]);

  ///---Retrieve----------------------------
  useEffect(() => {
    if (
      state.FormsIDList.Job_offer_id != "" &&
      state.FormsIDList.ActiveTabs == 10
    ) {
      const payload = {
        Retieveid: state.FormsIDList.Job_offer_id,
      };

      dispatch(SetJObofferCall(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);
  ///---Search----Client--Branch---

  const handleInputRoleChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      roleSearch: Val,
    });
  };
  const handleInputChangeZone = (Val) => {
    // setZoneSearch(Val);
    setSearchDebounance({
      ...SearchDebounance,
      Zonesearch: Val,
    });
  };

  useEffect(() => {
    // console.log(state.ZonePart.Zone, "Branch");
    if (state.ZonePart.Zone != undefined) {
      let branchlist = [];
      state.ZonePart.Zone.forEach((element) => {
        branchlist.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setbranchoptions(branchlist);
    }
  }, [state.ZonePart.Zone, ZoneSearch]);

  ////---Role-----

  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 10 &&
      data.client_id != null &&
      data.client_id != undefined &&
      data.client_id != "" &&
      data.client_id != "" &&
      data.client_id != undefined
    ) {
      const payload = {
        search: SearchedVal.roleSearch,
        page_size: 20,
        page: 1,
        mode: "",
        client: data.client_id,
        white_collar: false,
      };
      dispatch(getRoleListActions(payload));

      console.log(data.client_id, "qwiuioqweu data.client_id");
    }
  }, [
    state.FormsIDList.ActiveTabs == 10,
    data.client_id,
    SearchedVal.roleSearch,
  ]);

  ////-------Client---Barhnch---
  useEffect(() => {
    if (state.FormsIDList.ActiveTabs === 10) {
      const payload = {
        search: ZoneSearch,
        page_size: 20,
        page: 1,
        //  client:state.NumberCounts.BranchObjectJobInfoFieldAgent?.value,
        counts: 4,
        is_reliever: "false",
      };
      if (
        state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
        state?.SideBarFiles?.UserEmailID == "admin@qpms.in"
      ) {
        delete payload.is_reliever;
      }
      dispatch(setZoneActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs == 10, ZoneSearch]);

  ////---Role------

  useEffect(() => {
    // console.log(state.rolelists.RoleList, "tole");
    if (state.rolelists.RoleList != undefined) {
      let branchlist = [];

      state.rolelists.RoleList.forEach((element) => {
        branchlist.push({
          value: element.id,
          label: element.role.toUpperCase(),
        });
      });
      setROleoptionsList(branchlist);
    }
  }, [
    state.rolelists.RoleList,
    state.NumberCounts.BranchObjectJobInfoFieldAgent,
  ]);

  /////---Set------role---and---branch--valuews---based on---by clicking----branch---row , adn--clicking-the--role
  useEffect(() => {
    if (
      state.FormsIDList.Job_offer_id == "" &&
      // state.NumberCounts.EmployeeRoleId == "" &&
      state.NumberCounts.BranchObject != undefined &&
      state.NumberCounts.RoleOjects != undefined &&
      state.NumberCounts.Editable == 2
    ) {
      let IDs = [];
      SteBranchValue();
      setRoleValue(state.NumberCounts.RoleOjects);
      roleIDs = state.NumberCounts.RoleOjects.value; ///---role----id----

      //  console.log(state.NumberCounts.RoleOjects.value ,"asdasd");
      setData({
        ...data,
        designation_id: state.NumberCounts.RoleOjects.value,
      });
    }
    if (
      state.FormsIDList.Job_offer_id != "" &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id &&
      state.JOBOfferCall.JobDATATS != undefined &&
      state.JOBOfferCall.JobDATATS.designation_id != undefined &&
      state.JOBOfferCall.JobDATATS.designation_id != null
      // &&
      // state.NumberCounts.EmployeeRoleId != ""
    ) {
      let descriptionFromRepose = [];
      descriptionFromRepose.push({
        value: state.JOBOfferCall.JobDATATS.designation_id.id,
        label: state.JOBOfferCall.JobDATATS.designation_id.role,
      });
      setData({
        ...data,
        designation_id: state.JOBOfferCall.JobDATATS.designation_id.id,
      });
      setdesginationErr("");

      setRoleValue(descriptionFromRepose); ////----if the count is 2 then , the flow path is kyc verifications,site
      ///---if the designation_id is represent then we can display it or else it have to be empty
    }

    if (state.FormsIDList.Job_offer_id == "") {
      setSiteObjectVal(state.NumberCounts.ZONEobjects);
      setData({
        ...data,
        job_title: state.NumberCounts.ZONEobjects.value,
      });
      setTitelErr("");
    } else if (
      state.FormsIDList.Job_offer_id != "" &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id
    ) {
      setData({
        ...data,
        job_title: siteIDs,
      });
      setTitelErr("");
    }
    console.log(state.FormsIDList.Job_offer_id, "sduapsod Job_offer_id");
  }, [
    state.NumberCounts.RoleOjects,
    state.NumberCounts.BranchObject,
    state.JOBOfferCall.JobDATATS,
    // state.JOBOfferCall.JobDATATS
  ]);

  /////----Changes-------branch----
  const handleBranchChange = (val) => {
    SteBranchValue(val);
    setData({
      ...data,
      job_title: val.value,
    });
    setSiteObjectVal(val);
    setSiteIDS(val.value);
    if (state.NumberCounts.Editable == 1) {
      setRoleValue({ value: "", label: "Select" });

      dispatch(
        settheJobinfoBranchEmployeeProfile({
          value: "",
          label: "Select",
          is_reliever: false,
        }),
      );

      setData({
        ...data,
        client_id: "",
        designation_id: "",
      });
    }
  };

  const [value, setValue] = useState("");

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const parsedValue = parseFloat(inputValue);

    // Check if input exceeds 8 digits
    if (inputValue.length > 9) {
      setGrossError("*Indicative Salary cannot exceed 8 digits.");
      setErrInde(1);
      e.target.value = data.gross_salary; // Revert to previous valid value
      return;
    }

    // Check if input is less than or equal to 0
    if (parsedValue <= 0) {
      setGrossError("*Indicative Salary must be greater than 0.");
      setErrInde(1);
      e.target.value = "";
      return;
    }

    // Valid input
    setGrossError("");
    setErrInde(0);
    setData({
      ...data,
      gross_salary: inputValue,
    });
    HandleChanges(e);
  };

  const inputRef = useRef(null);
  const preventZoom = (event) => {
    console.log(event, "asdasdevent", event?.type == "wheel", "sadasdasd");

    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }

    if (event?.type == "wheel") {
      event.preventDefault();
    }

    if (["e", "E", "+", "-", "."].includes(event.key)) {
      event.preventDefault();
    }
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
    }

    // if (evt.ctrlKey || evt.metaKey) {
    //   evt.preventDefault();
    // }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      inputElement.addEventListener("wheel", preventZoom);
    }

    // Cleanup to remove the event listener when the component unmounts
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", preventZoom);
      }
    };
  }, []);

  const HandleBranchChanges = (e) => {
    if (e != null) {
      dispatch(
        settheJobinfoBranchEmployeeProfile({
          value: e.value,
          label: e.label,
          is_reliever: e?.is_reliever,
        }),
      );
      setRoleValue({ value: "", label: "Select" });
      dispatch(setthejobinformationroleID(""));

      setData({
        ...data,
        client_id: e.value,
        designation_id: "",
      });
    } else {
      dispatch(
        settheJobinfoBranchEmployeeProfile({
          value: "",
          label: "Select",
          is_reliever: false,
        }),
      );
      setRoleValue({ value: "", label: "Select" });
      dispatch(setthejobinformationroleID(""));

      setData({
        ...data,
        client_id: "",
        designation_id: "",
      });
    }
  };
  ///---Role-----
  const handleDesignationChange = (val) => {
    setRoleValue(val);
    setData({
      ...data,
      designation_id: val.value,
    });
    dispatch(setthejobinformationroleID(val.value));
    dispatch(SettheBracnhId(val.value));
  };
  const HandleChanges = (e) => {
    setData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value.toUpperCase(),
      };
    });
    if (e.target.name == "gross_salary") {
      dispatch(setTheGrossSalarayAmount(e.target.value));
    }
  };
  useEffect(() => {
    // console.log(state.JOBOfferCall.JobDATATS, "jobkjk");
    if (
      state.JOBOfferCall.JobDATATS.id != undefined &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id &&
      state.FormsIDList.Job_offer_id != ""
    ) {
      setData({
        ...data,
        job_title: siteIDs,
        department: state.JOBOfferCall.JobDATATS.department,
        designation: state.JOBOfferCall.JobDATATS.designation,
        gross_salary: state.JOBOfferCall.JobDATATS.gross_salary,
        designation_id:
          state.JOBOfferCall.JobDATATS.designation_id != undefined &&
          state.JOBOfferCall.JobDATATS.designation_id != null
            ? state.JOBOfferCall.JobDATATS.designation_id.id
            : "",
        client_id:
          state.JOBOfferCall.JobDATATS.client_id != undefined &&
          state.JOBOfferCall.JobDATATS.client_id != null
            ? state.JOBOfferCall.JobDATATS.client_id.id
            : state.NumberCounts.BranchObjectJobInfoFieldAgent != null &&
                state.NumberCounts.BranchObjectJobInfoFieldAgent != undefined &&
                state.NumberCounts.BranchObjectJobInfoFieldAgent != ""
              ? state.NumberCounts.BranchObjectJobInfoFieldAgent?.value
              : "",
        other_allowances_salary:
          state.JOBOfferCall.JobDATATS.other_allowances_salary,
        net_salary: state.JOBOfferCall.JobDATATS.net_salary,
        hra_salary: state.JOBOfferCall.JobDATATS.hra_salary,
        employee_PF: state.JOBOfferCall.JobDATATS.employee_PF,
        employee_ESI: state.JOBOfferCall.JobDATATS.employee_ESI,
        basic_salary: state.JOBOfferCall.JobDATATS.basic_salary,
        airtime_allowance: state.JOBOfferCall.JobDATATS.airtime_allowance,
      });

      const job = state.JOBOfferCall.JobDATATS;
      if (!job) return;

      // 1) fill uniforms from JobDATATS
      setUniforms((prev) => ({
        ...prev,
        shirt_size: job?.shirt_size ?? null,
        pant_size: job?.pant_size ?? null,
        shoe_size: job?.shoe_size ?? null,
        apron_size: job?.apron_size ?? null,
        top_size: job?.top_size ?? null,
        salwar_size: job?.salwar_size ?? null,
        t_shirt_size: job?.t_shirt_size ?? null,
        chef_coat_size: job?.chef_coat_size ?? null,
        dupatta_size: job?.dupatta_size ?? null,
        saree_size: job?.saree_size ?? null,
        rain_coat_size: job?.rain_coat_size ?? null,
        safari_size: job?.safari_size ?? null,
        cargo_pant_size: job?.cargo_pant_size ?? null,
        boots_size: job?.boots_size ?? null,
        cap_count: job?.cap_count ?? null,
        belt_count: job?.belt_count ?? null,
        lanyard_count: job?.lanyard_count ?? null,
        whishel_count: job?.whishel_count ?? null,
        umbrella_count: job?.umbrella_count ?? null,
        torch_light_count: job?.torch_light_count ?? null,
        traffic_control_torch_light_count:
          job?.traffic_control_torch_light_count ?? null,
      }));
      const derivedSelected = uniformKeys.filter((key) => {
        const v = job?.[key];
        return v !== null && v !== undefined && v !== "";
      });

      // if API already sends selected_uniforms, prefer that
      if (
        Array.isArray(job?.selected_uniforms) &&
        job.selected_uniforms.length
      ) {
        setSelectedUniforms(job.selected_uniforms);
      } else {
        setSelectedUniforms(derivedSelected);
      }

      setthebasic(
        state.JOBOfferCall.JobDATATS.other_allowances_salary != "" ||
          state.JOBOfferCall.JobDATATS.net_salary != "" ||
          state.JOBOfferCall.JobDATATS.employee_PF != "" ||
          state.JOBOfferCall.JobDATATS.employee_ESI != "" ||
          state.JOBOfferCall.JobDATATS.basic_salary != "" ||
          state.JOBOfferCall.JobDATATS.airtime_allowance != ""
          ? true
          : false,
      );

      setTitelErr("");
      setdesginationErr("");

      setGrossError("");
      if (
        state.FormsIDList.Job_offer_id != "" &&
        state.JOBOfferCall.JobDATATS.client_id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_job_description == true &&
        state.JOBOfferCall.JobDATATS.client_id != null
      ) {
        console.log("aslkdklsajd joinings");

        dispatch(
          settheJobinfoBranchEmployeeProfile({
            value: state.JOBOfferCall.JobDATATS.client_id.id,
            label: state.JOBOfferCall.JobDATATS?.client_id?.branch_code
              ? `${state.JOBOfferCall.JobDATATS.client_id.branch_code} - ${state.JOBOfferCall.JobDATATS.client_id.client_name ?? ""}`
              : `${state.JOBOfferCall.JobDATATS?.client_id?.client_name ?? ""}`,

            is_reliever: state.JOBOfferCall.JobDATATS.client_id.is_reliever,
          }),
        );
      }
      // else if(state.JOBOfferCall.JobDATATS.client_id== undefined &&
      //   state.JOBOfferCall.JobDATATS.client_id == null) {
      //     dispatch(settheJobinfoBranchEmployeeProfile({value:"",label:"Select"}))

      // }

      dispatch(
        setTheGrossSalarayAmount(state.JOBOfferCall.JobDATATS.gross_salary),
      );
    }
  }, [
    state.JOBOfferCall.JobDATATS,
    siteObjectVal,
    state.FormsIDList.ActiveTabs,
  ]);

  useEffect(() => {
    if (state.FormsIDList.Job_offer_id == "") {
      if (
        // state.JOBOfferCall.JobDATATS.client_id == null &&state.JOBOfferCall.JobDATATS.client_id== undefined &&
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.is_job_description == true
      ) {
        if (
          state.EmployeeProfile.EmployeeProfileList != undefined &&
          state.EmployeeProfile.EmployeeProfileList != "" &&
          state.EmployeeProfile.EmployeeProfileList.client_id != null &&
          state.EmployeeProfile.EmployeeProfileList.client_id != undefined &&
          state.EmployeeProfile.EmployeeProfileList.is_job_description == true
        ) {
          console.log("aslkdklsajd joinings");

          dispatch(
            settheJobinfoBranchEmployeeProfile({
              value: state.EmployeeProfile.EmployeeProfileList.client_id.id,
              label: state.EmployeeProfile.EmployeeProfileList?.client_id
                ?.branch_code
                ? `${state.EmployeeProfile.EmployeeProfileList.client_id.branch_code} - ${state.EmployeeProfile.EmployeeProfileList.client_id.client_name ?? ""}`
                : `${state.EmployeeProfile.EmployeeProfileList?.client_id?.client_name ?? ""}`,
              is_reliever:
                state.EmployeeProfile.EmployeeProfileList?.client_id
                  ?.is_reliever,
            }),
          );
        }
      } ///---job information inclient id
    }
  }, [
    state.EmployeeProfile.EmployeeProfileList &&
      state.EmployeeProfile.EmployeeProfileList?.is_job_description == true,
  ]);

  useEffect(() => {
    if (
      state.JOBOfferCall.JobDATATS.id != undefined &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id &&
      state.FormsIDList.Job_offer_id != "" &&
      state.JOBOfferCall.JobDATATS.site_id != null &&
      state.JOBOfferCall.JobDATATS.site_id != undefined &&
      state.JOBOfferCall.JobDATATS.site_id.id != undefined
    ) {
      IDS = state.JOBOfferCall.JobDATATS.site_id.id;
      setSiteObjectVal({
        value: state.JOBOfferCall.JobDATATS.site_id.id,
        label: state.JOBOfferCall.JobDATATS.site_id.zone_name.toUpperCase(),
      });
      setSiteIDS(IDS);
      setRetrveeId(IDS);
    }
  }, [state.JOBOfferCall.JobDATATS]);
  //  console.log(state.FormsIDList.Job_offer_id, "JobOffers SetJObofferCallAction");
  ///////////////--------- next------APi-----Call
  console.log(
    data,
    "euoiwopeiqwoiepoie",
    state.NumberCounts.BranchObjectJobInfoFieldAgent,
    state.JOBOfferCall.JobDATATS,
  );

  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 3 &&
      state.FormsIDList.ActiveTabs == 10 &&
      state.FormsIDList.Idverify == "" &&
      state.BasicFormCreated.user_ID != undefined &&
      state.BasicFormCreated.user_ID != ""
    ) {
      const payload = {
        type: "IDF",
        // userId: state.BasicFormCreated.BacicDatas.user_id,
        userId: state.BasicFormCreated.user_ID,
      };
      dispatch(setPreviousDataFetchActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);
  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 10 &&
      // state.FormsIDList.Idverify == "" &&
      state.PreviousApiCallLine.PreviousDatas &&
      state.PreviousApiCallLine.PreviousDatas.id
    ) {
      dispatch(SetIdVeriications(state.PreviousApiCallLine.PreviousDatas.id));
    }
  }, [state.PreviousApiCallLine.PreviousDatas, state.FormsIDList.ActiveTabs]);

  // console.log(
  //   state.PreviousApiCallLine.PreviousDatas,
  //   "PreviousDatas",
  // );
  // console.log(
  //   state.FormsIDList.Idverify,
  //   "Idverify",
  //   state.PreviousApiCallLine.PreviousDatas.id
  // );

  const getUniformValue = (key) => {
    // not selected in the multi-select -> send null
    if (!selectedUniforms.includes(key)) return null;

    const val = uniforms?.[key];

    // if empty string / undefined / null -> send null
    if (val === "" || val === undefined || val === null) return null;

    return val; // for counts you can wrap with Number(val) if needed
  };

  const validateSelectedUniformFields = () => {
    const errors = {};
    let isValid = true;

    if (selectedUniforms.length === 0) {
      setSelectedUniformsError("Select uniforms is required");
      isValid = false;
    } else {
      setSelectedUniformsError("");
    }

    selectedUniforms.forEach((key) => {
      const val = uniforms?.[key];

      if (val === "" || val === undefined || val === null) {
        errors[key] = `${uniformConfig[key]?.label || "Uniform field"} is required`;
      }
    });

    setUniformErrors(errors);
    return isValid && Object.keys(errors).length === 0;
  };

  console.log(data, "kjdjajsjkakj", selectedUniforms, "dsdasdasdkasdkalkd");
  const HandleNext = () => {
    var a = 0;
    if (!validateSelectedUniformFields()) {
      a = 1;
    }
    if (state.FormsIDList.Job_offer_id == "") {
      // if(state.NumberCounts.Editable != 1){

      if (data.job_title == "") {
        a = 1;
        setTitelErr("Zone is required");
      }

      if (data.designation_id == "") {
        a = 1;
        setdesginationErr("Designation is required");
      }

      if (data.gross_salary == "") {
        a = 1;
        setGrossError("Salary  is required");
      }
      if (data.gross_salary != "" && data.gross_salary == 0) {
        a = 1;
        setGrossError("Indicative Salary must be greater than 0.");
      }
      if (data.gross_salary != "" && data.gross_salary.length > 8) {
        a = 1;
        setGrossError("Indicative Salary cannot exceed 8 digits");
      }

      if (
        data.basic_salary !== "" &&
        data.basic_salary !== null &&
        data.basic_salary.length > 8
      ) {
        a = 1;
        setBasicErr("Basic Salary cannot exceed 8 digits.");
      }

      if (
        data.hra_salary !== "" &&
        data.hra_salary !== null &&
        data.hra_salary.length > 8
      ) {
        a = 1;
        setHraErr("HRA Salary cannot exceed 8 digits.");
      }

      if (
        data.other_allowances_salary !== "" &&
        data.other_allowances_salary !== null &&
        data.other_allowances_salary.length > 8
      ) {
        a = 1;
        setOtherErr("Other Allowances cannot exceed 8 digits.");
      }

      if (
        data.employee_ESI !== "" &&
        data.employee_ESI !== null &&
        data.employee_ESI.length > 8
      ) {
        a = 1;
        setESIerr("ESI cannot exceed 8 digits.");
      }

      if (
        data.employee_PF !== "" &&
        data.employee_PF !== null &&
        data.employee_PF.length > 8
      ) {
        a = 1;
        setPFerr("PF cannot exceed 8 digits.");
      }

      if (
        data.net_salary !== "" &&
        data.net_salary !== null &&
        data.net_salary.length > 8
      ) {
        a = 1;
        setNetSalarErr("Net Salary cannot exceed 8 digits.");
      }

      if (
        data.airtime_allowance !== "" &&
        data.airtime_allowance !== null &&
        data.airtime_allowance.length > 8
      ) {
        a = 1;
        setAirTimeAllo("Airtime Allowance cannot exceed 8 digits.");
      }

      if (data.client_id == "") {
        setbranchMantory("Client is required");
      }
      // }

      // ErrorInde == 0
      // console.log(data, "asdasdasd" , state.EmployeeProfile.EmployeeProfileList.id , state.BasicFormCreated.BasciFormCreate);
      if (a == 0 && ErrorInde == 0) {
        dispatch(setTherossSalaryCreateActions(data.gross_salary));
        const Jobinfocreate = {
          site_id: data.job_title,
          // department: payload.payload.data.department,
          department: "wbs",
          designation_id: data.designation_id,
          gross_salary: data.gross_salary,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          client_id: data.client_id,
          other_allowances_salary:
            addbasic == true
              ? data.other_allowances_salary == 0
                ? ""
                : data.other_allowances_salary
              : "",
          airtime_allowance:
            addbasic == true
              ? data.airtime_allowance == 0
                ? ""
                : data.airtime_allowance
              : "",
          net_salary:
            addbasic == true
              ? data.net_salary == 0
                ? ""
                : data.net_salary
              : "",
          hra_salary:
            addbasic == true
              ? data.hra_salary == 0
                ? ""
                : data.hra_salary
              : "",
          employee_PF:
            addbasic == true
              ? data.employee_PF == 0
                ? ""
                : data.employee_PF
              : "",
          employee_ESI:
            addbasic == true
              ? data.employee_ESI == 0
                ? ""
                : data.employee_ESI
              : "",
          basic_salary:
            addbasic == true
              ? data.basic_salary == 0
                ? ""
                : data.basic_salary
              : "",
          shirt_size: getUniformValue("shirt_size"),
          pant_size: getUniformValue("pant_size"),
          shoe_size: getUniformValue("shoe_size"),
          apron_size: getUniformValue("apron_size"),
          top_size: getUniformValue("top_size"),
          salwar_size: getUniformValue("salwar_size"),
          t_shirt_size: getUniformValue("t_shirt_size"),
          chef_coat_size: getUniformValue("chef_coat_size"),
          dupatta_size: getUniformValue("dupatta_size"),
          saree_size: getUniformValue("saree_size"),
          rain_coat_size: getUniformValue("rain_coat_size"),
          safari_size: getUniformValue("safari_size"),
          cargo_pant_size: getUniformValue("cargo_pant_size"),
          boots_size: getUniformValue("boots_size"),

          // counts
          cap_count: getUniformValue("cap_count"),
          belt_count: getUniformValue("belt_count"),
          lanyard_count: getUniformValue("lanyard_count"),
          whishel_count: getUniformValue("whishel_count"),
          umbrella_count: getUniformValue("umbrella_count"),
          torch_light_count: getUniformValue("torch_light_count"),
          traffic_control_torch_light_count: getUniformValue(
            "traffic_control_torch_light_count",
          ),
          selected_uniforms: selectedUniforms,
        };
        const payload = {
          data: data,
          Jobinfocreate: Jobinfocreate,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          designation_id: data.designation_id,
          //timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
        };

        dispatch(SetJObofferCallAction(payload));
      }
    } else if (
      state.FormsIDList.Job_offer_id != "" &&
      state.JOBOfferCall.JobDATATS != []
    ) {
      //  if(state.NumberCounts.Editable != 1){
      if (data.job_title == "") {
        a = 1;
        setTitelErr("Zone is required");
      }
      if (data.designation_id == "") {
        a = 1;
        setdesginationErr("Designation is required");
      }

      if (data.gross_salary == "") {
        a = 1;
        setGrossError("Salary  is required");
      }
      if (data.gross_salary != "" && data.gross_salary == 0) {
        a = 1;
        setGrossError("Indicative Salary must be greater than 0.");
      }
      if (
        data.gross_salary != "" &&
        data.gross_salary != null &&
        data.gross_salary.length > 8
      ) {
        a = 1;
        setGrossError("Indicative Salary cannot exceed 8 digits");
      }

      if (data.client_id == "") {
        setbranchMantory("Client is required");
        a = 1;
      }

      if (
        data.basic_salary !== "" &&
        data.basic_salary !== null &&
        data.basic_salary.length > 8
      ) {
        a = 1;
        setBasicErr("Basic Salary cannot exceed 8 digits.");
      }

      if (
        data.hra_salary !== "" &&
        data.hra_salary !== null &&
        data.hra_salary.length > 8
      ) {
        a = 1;
        setHraErr("HRA Salary cannot exceed 8 digits.");
      }

      if (
        data.other_allowances_salary !== "" &&
        data.other_allowances_salary !== null &&
        data.other_allowances_salary.length > 8
      ) {
        a = 1;
        setOtherErr("Other Allowances cannot exceed 8 digits.");
      }

      if (
        data.employee_ESI !== "" &&
        data.employee_ESI !== null &&
        data.employee_ESI.length > 8
      ) {
        a = 1;
        setESIerr("ESI cannot exceed 8 digits.");
      }

      if (
        data.employee_PF !== "" &&
        data.employee_PF !== null &&
        data.employee_PF.length > 8
      ) {
        a = 1;
        setPFerr("PF cannot exceed 8 digits.");
      }

      if (
        data.net_salary !== "" &&
        data.net_salary !== null &&
        data.net_salary.length > 8
      ) {
        a = 1;
        setNetSalarErr("Net Salary cannot exceed 8 digits.");
      }

      if (
        data.airtime_allowance !== "" &&
        data.airtime_allowance !== null &&
        data.airtime_allowance.length > 8
      ) {
        a = 1;
        setAirTimeAllo("Airtime Allowance cannot exceed 8 digits.");
      }

      if (a == 0 && ErrorInde == 0) {
        if (
          data.designation_id !=
            state.JOBOfferCall.JobDATATS.designation_id?.id ||
          data.gross_salary != state.JOBOfferCall.JobDATATS.gross_salary ||
          data.job_title != retrievedid ||
          data.client_id != state.JOBOfferCall.JobDATATS.client_id?.id ||
          data.other_allowances_salary !=
            state.JOBOfferCall.JobDATATS.other_allowances_salary ||
          data.net_salary != state.JOBOfferCall.JobDATATS.net_salary ||
          data.hra_salary != state.JOBOfferCall.JobDATATS.hra_salary ||
          data.employee_PF != state.JOBOfferCall.JobDATATS.employee_PF ||
          data.employee_ESI != state.JOBOfferCall.JobDATATS.employee_ESI ||
          data.basic_salary != state.JOBOfferCall.JobDATATS.basic_salary ||
          data.airtime_allowance !=
            state.JOBOfferCall.JobDATATS.airtime_allowance ||
          uniforms.shirt_size != state.JOBOfferCall.JobDATATS.shirt_size ||
          uniforms.pant_size != state.JOBOfferCall.JobDATATS.pant_size ||
          uniforms.shoe_size != state.JOBOfferCall.JobDATATS.shoe_size ||
          uniforms.apron_size != state.JOBOfferCall.JobDATATS.apron_size ||
          uniforms.top_size != state.JOBOfferCall.JobDATATS.top_size ||
          uniforms.salwar_size != state.JOBOfferCall.JobDATATS.salwar_size ||
          uniforms.t_shirt_size != state.JOBOfferCall.JobDATATS.t_shirt_size ||
          uniforms.chef_coat_size !=
            state.JOBOfferCall.JobDATATS.chef_coat_size ||
          uniforms.shirt_dupatta_sizesize !=
            state.JOBOfferCall.JobDATATS.dupatta_size ||
          uniforms.saree_size != state.JOBOfferCall.JobDATATS.saree_size ||
          uniforms.rain_coat_size !=
            state.JOBOfferCall.JobDATATS.rain_coat_size ||
          uniforms.safari_size != state.JOBOfferCall.JobDATATS.safari_size ||
          uniforms.cargo_pant_size !=
            state.JOBOfferCall.JobDATATS.cargo_pant_size ||
          uniforms.boots_size != state.JOBOfferCall.JobDATATS.boots_size ||
          uniforms.cap_count != state.JOBOfferCall.JobDATATS.cap_count ||
          uniforms.belt_count != state.JOBOfferCall.JobDATATS.belt_count ||
          uniforms.lanyard_count !=
            state.JOBOfferCall.JobDATATS.lanyard_count ||
          uniforms.whishel_count !=
            state.JOBOfferCall.JobDATATS.whishel_count ||
          uniforms.umbrella_count !=
            state.JOBOfferCall.JobDATATS.umbrella_count ||
          uniforms.torch_light_count !=
            state.JOBOfferCall.JobDATATS.torch_light_count ||
          uniforms.traffic_control_torch_light_count !=
            state.JOBOfferCall.JobDATATS.traffic_control_torch_light_count ||
          selectedUniforms != state.JOBOfferCall.JobDATATS?.selected_uniforms
        ) {
          dispatch(setTherossSalaryActions(data.gross_salary)); //----if--the gross salary is more than 20,000 then only the pan card is important
          const Jobinfocreate = {
            site_id: data.job_title,
            // department: payload.payload.data.department,
            department: "wbs",
            designation_id: data.designation_id,
            gross_salary: data.gross_salary,
            timeline_id:
              state.BasicFormCreated.BasciFormCreate == ""
                ? state.EmployeeProfile.EmployeeProfileList.id
                : state.BasicFormCreated.BasciFormCreate,
            client_id: data.client_id,
            other_allowances_salary:
              addbasic == true
                ? data.other_allowances_salary == 0
                  ? ""
                  : data.other_allowances_salary
                : "",
            airtime_allowance:
              addbasic == true
                ? data.airtime_allowance == 0
                  ? ""
                  : data.airtime_allowance
                : "",
            net_salary:
              addbasic == true
                ? data.net_salary == 0
                  ? ""
                  : data.net_salary
                : "",
            hra_salary:
              addbasic == true
                ? data.hra_salary == 0
                  ? ""
                  : data.hra_salary
                : "",
            employee_PF:
              addbasic == true
                ? data.employee_PF == 0
                  ? ""
                  : data.employee_PF
                : "",
            employee_ESI:
              addbasic == true
                ? data.employee_ESI == 0
                  ? ""
                  : data.employee_ESI
                : "",
            basic_salary:
              addbasic == true
                ? data.basic_salary == 0
                  ? ""
                  : data.basic_salary
                : "",

            shirt_size: getUniformValue("shirt_size"),
            pant_size: getUniformValue("pant_size"),
            shoe_size: getUniformValue("shoe_size"),
            apron_size: getUniformValue("apron_size"),
            top_size: getUniformValue("top_size"),
            salwar_size: getUniformValue("salwar_size"),
            t_shirt_size: getUniformValue("t_shirt_size"),
            chef_coat_size: getUniformValue("chef_coat_size"),
            dupatta_size: getUniformValue("dupatta_size"),
            saree_size: getUniformValue("saree_size"),
            rain_coat_size: getUniformValue("rain_coat_size"),
            safari_size: getUniformValue("safari_size"),
            cargo_pant_size: getUniformValue("cargo_pant_size"),
            boots_size: getUniformValue("boots_size"),

            // counts
            cap_count: getUniformValue("cap_count"),
            belt_count: getUniformValue("belt_count"),
            lanyard_count: getUniformValue("lanyard_count"),
            whishel_count: getUniformValue("whishel_count"),
            umbrella_count: getUniformValue("umbrella_count"),
            torch_light_count: getUniformValue("torch_light_count"),
            traffic_control_torch_light_count: getUniformValue(
              "traffic_control_torch_light_count",
            ),
            selected_uniforms: selectedUniforms,
          };

          const payload = {
            data: data,
            Jobinfocreate: Jobinfocreate,
            timeline_id:
              state.BasicFormCreated.BasciFormCreate == ""
                ? state.EmployeeProfile.EmployeeProfileList.id
                : state.BasicFormCreated.BasciFormCreate,

            // designation_id: state.NumberCounts.RoleOjects.value,
            designation_id: data.designation_id,
            Retieveid: state.FormsIDList.Job_offer_id,
          };
          dispatch(SetJObofferDITCallAction(payload));
        } else if (a == 0) {
          if (
            state.FormsIDList.Job_offer_id != "" &&
            state.JOBOfferCall.JobDATATS != [] &&
            data.designation_id ==
              state.JOBOfferCall.JobDATATS.designation_id?.id &&
            data.client_id == state.JOBOfferCall.JobDATATS.client_id?.id &&
            data.gross_salary == state.JOBOfferCall.JobDATATS.gross_salary &&
            data.job_title == retrievedid &&
            data.other_allowances_salary ==
              state.JOBOfferCall.JobDATATS.other_allowances_salary &&
            data.net_salary == state.JOBOfferCall.JobDATATS.net_salary &&
            data.hra_salary == state.JOBOfferCall.JobDATATS.hra_salary &&
            data.employee_PF == state.JOBOfferCall.JobDATATS.employee_PF &&
            data.employee_ESI == state.JOBOfferCall.JobDATATS.employee_ESI &&
            data.basic_salary == state.JOBOfferCall.JobDATATS.basic_salary
          ) {
            dispatch(SetActiveTabs(3));
          }
        }
      }
    }
  };
  const HandlePrevious = () => {
    dispatch(SetActiveTabs(2));
  };

  console.log(
    "Basic_gender_datas supdoasid",
    state.NumberCounts.BranchObjectJobInfoFieldAgent,
    state.EmployeeProfile.EmployeeProfileList,
  );

  return (
    <div>
      <div className=" BodyContent jobOfferIngfor">
        <div className="card">
          <div className="card-body cards ">
            <div className="UserPoup">
              <div className="BeforForms">
                <div className="Form">
                  <div className="ModalHeader">
                    <div>
                      <span>Job Information</span>
                    </div>
                  </div>
                  <div className="Modal-Body ModalForms">
                    <div className="row">
                      <div className="col-12 mt-3">
                        <div>
                          <span
                            style={{
                              color: "#234492",
                              fontWeight: "550",
                              fontSize: "17px",
                            }}
                          >
                            Employment Details
                          </span>{" "}
                          {/* 👈 Change title here */}
                        </div>

                        <div className="row mt-3">
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Site
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              menuPlacement="top"
                              //  className="Selects "
                              styles={{ position: "relative", top: "60px" }}
                              isDisabled={
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.is_reliever == true
                                  ? state.SideBarFiles.UserEmailID ==
                                      "admin@gmail.com" ||
                                    state.SideBarFiles.UserEmailID ==
                                      "admin@qpms.in"
                                    ? false
                                    : true
                                  : // siteObjectVal?.label?.toLowerCase().includes("reliever") ? true:
                                    // state.NumberCounts.Editable == 1 && state.ClientBranchIDs.SUBROLE != 3 ? true : false
                                    state.NumberCounts.Editable == 2 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                        true
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                          false &&
                                        state.NumberCounts.Editable == 1 &&
                                        (state.ClientBranchIDs.SUBROLE != 3 ||
                                          state.ClientBranchIDs.SUBROLE == 0 ||
                                          state.ClientBranchIDs.SUBROLE == 1)
                                      ? //  false
                                        true
                                      : state.NumberCounts.EmployeeFormFIll ==
                                            true &&
                                          state.ClientBranchIDs.SUBROLE == 2
                                        ? true
                                        : state.NumberCounts.Editable == 2
                                          ? true
                                          : state.ClientBranchIDs.SUBROLE == 3
                                            ? false
                                            : false
                              }
                              onChange={(e) => {
                                handleBranchChange(e);
                                setTitelErr("");
                              }}
                              name="BranchSearch"
                              onInputChange={handleInputChangeZone}
                              options={branchoptions}
                              labelledBy="Select"
                              value={siteObjectVal}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {jobtotitleErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Client
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              styles={{ position: "relative", top: "60px" }}
                              menuPlacement="top"
                              isDisabled={
                                // state.NumberCounts.Editable == 2
                                // ?
                                //  true:
                                //  state.NumberCounts.Editable == 1 &&
                                //  state.ClientBranchIDs.SUBROLE == 3 ||
                                //  state.ClientBranchIDs.SUBROLE == 0
                                //  ||
                                //  state.ClientBranchIDs.SUBROLE == 1  &&
                                //  state.NumberCounts.EmployeeFormFIll == false
                                //  ?
                                //  false :
                                //  state.ClientBranchIDs.SUBROLE ==2  && state.NumberCounts.EmployeeFormFIll == true ?
                                //  true :
                                //  false
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.is_reliever == true
                                  ? state.SideBarFiles.UserEmailID ==
                                      "admin@gmail.com" ||
                                    state.SideBarFiles.UserEmailID ==
                                      "admin@qpms.in"
                                    ? false
                                    : true
                                  : state.NumberCounts.Editable == 2 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                        true
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                          false &&
                                        state.NumberCounts.Editable == 1 &&
                                        (state.ClientBranchIDs.SUBROLE != 3 ||
                                          state.ClientBranchIDs.SUBROLE == 0 ||
                                          state.ClientBranchIDs.SUBROLE == 1)
                                      ? //  false
                                        true
                                      : state.NumberCounts.EmployeeFormFIll ==
                                            true &&
                                          state.ClientBranchIDs.SUBROLE == 2
                                        ? true
                                        : state.NumberCounts.Editable == 2
                                          ? true
                                          : false
                              }
                              onChange={(e) => {
                                HandleBranchChanges(e);
                                setbranchMantory("");
                              }}
                              name="BranchSearch"
                              labelledBy="Select"
                              options={nameList4}
                              value={
                                state.NumberCounts.BranchObjectJobInfoFieldAgent
                              }
                              onInputChange={HandleInputBranch}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {branchMantory}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Designation
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              className="Selects stateNames"
                              styles={{ position: "relative", top: "60px" }}
                              menuPlacement="top"
                              onChange={(e) => {
                                handleDesignationChange(e);
                                setdesginationErr("");
                              }}
                              isDisabled={
                                // state.NumberCounts.Editable == 1 &&
                                // SubRoleList != 0 &&
                                // SubRoleList != 1 &&
                                // state.ClientBranchIDs.SUBROLE != 3 &&
                                // state.NumberCounts.EmployeeFormFIll == true
                                //   ? true
                                //   : false
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.is_reliever == true
                                  ? state.SideBarFiles.UserEmailID ==
                                      "admin@gmail.com" ||
                                    state.SideBarFiles.UserEmailID ==
                                      "admin@qpms.in"
                                    ? false
                                    : true
                                  : state.NumberCounts.Editable == 2 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                        true
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                          false &&
                                        state.NumberCounts.Editable == 1 &&
                                        (state.ClientBranchIDs.SUBROLE != 3 ||
                                          state.ClientBranchIDs.SUBROLE == 0 ||
                                          state.ClientBranchIDs.SUBROLE == 1)
                                      ? //  false
                                        true
                                      : state.NumberCounts.EmployeeFormFIll ==
                                            true &&
                                          state.ClientBranchIDs.SUBROLE == 2
                                        ? true
                                        : false
                              }
                              name="roleSearch"
                              onInputChange={handleInputRoleChange}
                              options={roleoptionsList}
                              value={RoleValue}
                              labelledBy="Select"
                              disabled={
                                RoleValue?.label
                                  ?.toLowerCase()
                                  .includes("reliever")
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                        true
                                    ? true
                                    : false
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {designationerr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Indicative Salary
                            </label>

                            <span style={{ color: "red" }}>* </span>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setGrossError(
                                    "*Indicative Salary cannot exceed 8 digits.",
                                  );
                                  setErrInde(1);
                                  // Revert to previous valid value
                                  setData({
                                    ...data,
                                    gross_salary: data.gross_salary, // keep the previous value
                                  });
                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (parsedValue <= 0) {
                                  setGrossError(
                                    "*Indicative Salary must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    gross_salary: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setGrossError("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  gross_salary: value,
                                });
                              }}
                              autocomplete="off"
                              name="gross_salary"
                              value={data.gross_salary}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {grossSalaryErr}
                            </p>
                          </div>

                          <>
                            <div className="col-sm-3 mt-3 ">
                              <label
                                for="validationCustom01"
                                class="form-label  p-0 col-6"
                              >
                                Add Basic Salary
                              </label>

                              <input
                                class="form-check-input col-2 JobInfoFields"
                                type="checkbox"
                                checked={addbasic}
                                onChange={(e) => {
                                  setthebasic(!addbasic);
                                  setData({
                                    ...data,
                                    other_allowances_salary: "",
                                    net_salary: "",
                                    hra_salary: "",
                                    employee_PF: "",
                                    employee_ESI: "",
                                    basic_salary: "",
                                    airtime_allowance: "",
                                  });
                                  setErrInde(0);
                                }}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            true
                                        ? false
                                        : state.ClientBranchIDs.SUBROLE == 0 &&
                                            state.NumberCounts
                                              .EmployeeFormFIll == false
                                          ? true
                                          : state.NumberCounts
                                                .EmployeeFormFIll == true &&
                                              state.ClientBranchIDs.SUBROLE == 1
                                            ? false
                                            : state.NumberCounts.Editable == 2
                                              ? false
                                              : true
                                }
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : state.NumberCounts.Editable == 1 &&
                                        state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            true
                                        ? false
                                        : state.ClientBranchIDs.SUBROLE == 0 &&
                                            state.NumberCounts
                                              .EmployeeFormFIll == false
                                          ? true
                                          : state.NumberCounts
                                                .EmployeeFormFIll == true &&
                                              state.ClientBranchIDs.SUBROLE == 1
                                            ? false
                                            : state.NumberCounts.Editable == 2
                                              ? false
                                              : true
                                }
                              />
                            </div>

                            {addbasic == true ? (
                              <>
                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Basic Salary
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 8) {
                                        setBasicErr(
                                          "*Basic Salary cannot exceed 8 digits.",
                                        );
                                        setErrInde(1);
                                        // Revert to previous valid value
                                        // setData({
                                        //   ...data,
                                        //   basic_salary: data.basic_salary // keep the previous value
                                        // });
                                        return;
                                      }

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setBasicErr(
                                          "*Basic Salary must be greater than 0.",
                                        );
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          basic_salary: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setBasicErr("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        basic_salary: value,
                                      });
                                    }}
                                    autocomplete="off"
                                    name="basic_salary"
                                    value={data.basic_salary}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />
                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {basicErro}
                                  </p>
                                </div>
                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    HRA
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 8) {
                                        setHraErr(
                                          "*HRA Salary cannot exceed 8 digits.",
                                        );
                                        setErrInde(1);
                                        // Revert to previous valid value
                                        // setData({
                                        //   ...data,
                                        //   basic_salary: data.basic_salary // keep the previous value
                                        // });
                                        return;
                                      }

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setHraErr(
                                          "*HRA Salary must be greater than 0.",
                                        );
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          hra_salary: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setHraErr("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        hra_salary: value,
                                      });
                                    }}
                                    // ref={inputRef}
                                    autocomplete="off"
                                    name="hra_salary"
                                    value={data.hra_salary}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    //  style={{height:"45%"}}

                                    // onChange={handleChange}
                                    // onInput={handleChange}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />

                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {hraerr}
                                  </p>
                                </div>
                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Other Allowances
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 8) {
                                        setOtherErr(
                                          "*Other Allowances  cannot exceed 8 digits.",
                                        );
                                        setErrInde(1);
                                        // Revert to previous valid value
                                        // setData({
                                        //   ...data,
                                        //   basic_salary: data.basic_salary // keep the previous value
                                        // });
                                        return;
                                      }

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setOtherErr(
                                          "*Other Allowances  must be greater than 0.",
                                        );
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          other_allowances_salary: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setOtherErr("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        other_allowances_salary: value,
                                      });
                                    }}
                                    // ref={inputRef}
                                    autocomplete="off"
                                    name="other_allowances_salary"
                                    value={data.other_allowances_salary}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    //  style={{height:"45%"}}

                                    // onChange={handleChange}
                                    // onInput={handleChange}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />
                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {otherErr}
                                  </p>
                                </div>

                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Employee ESI
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;
                                      console.log(values, "093-0912093values");

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 8) {
                                        setESIerr(
                                          "*ESI cannot exceed 8 digits.",
                                        );
                                        setErrInde(1);

                                        return;
                                      }

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setESIerr(
                                          "*ESI must be greater than 0.",
                                        );
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          employee_ESI: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setESIerr("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        employee_ESI: value,
                                      });
                                    }}
                                    // ref={inputRef}
                                    autocomplete="off"
                                    name="employee_ESI"
                                    value={data.employee_ESI}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    //  style={{height:"45%"}}

                                    // onChange={handleChange}
                                    // onInput={handleChange}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />

                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {ESIErr}
                                  </p>
                                </div>
                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Employee PF
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 9) {
                                        setPFerr("*PF cannot exceed 8 digits.");
                                        setErrInde(1);

                                        return;
                                      }
                                      console.log(
                                        value.length,
                                        "value.length234",
                                      );

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setPFerr("*PF must be greater than 0.");
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          employee_PF: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setPFerr("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        employee_PF: value,
                                      });
                                    }}
                                    // ref={inputRef}
                                    autocomplete="off"
                                    name="employee_PF"
                                    value={data.employee_PF}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    //  style={{height:"45%"}}

                                    // onChange={handleChange}
                                    // onInput={handleChange}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />

                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {pferr}
                                  </p>
                                </div>

                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Airtime Allowance
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 8) {
                                        setAirTimeAllo(
                                          "*Airtime Allowance cannot exceed 8 digits.",
                                        );
                                        setErrInde(1);

                                        return;
                                      }

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setAirTimeAllo(
                                          "*Airtime Allowance must be greater than 0.",
                                        );
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          airtime_allowance: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setAirTimeAllo("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        airtime_allowance: value,
                                      });
                                    }}
                                    // ref={inputRef}
                                    autocomplete="off"
                                    name="airtime_allowance"
                                    value={data.airtime_allowance}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    //  style={{height:"45%"}}

                                    // onChange={handleChange}
                                    // onInput={handleChange}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />

                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {AirTimeErr}
                                  </p>
                                </div>

                                <div className="col-sm-3 mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    Net Salary
                                  </label>

                                  <NumericFormat
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                      const { value } = values;

                                      // Parse the value as a number
                                      const parsedValue = parseFloat(value);

                                      // Check if input exceeds 8 digits
                                      if (value.length > 8) {
                                        setNetSalarErr(
                                          "*Net Salary cannot exceed 8 digits.",
                                        );
                                        setErrInde(1);

                                        return;
                                      }

                                      // Check if input is less than or equal to 0
                                      if (parsedValue <= 0) {
                                        setNetSalarErr(
                                          "*Net Salary must be greater than 0.",
                                        );
                                        setErrInde(1);
                                        // Clear the field
                                        setData({
                                          ...data,
                                          net_salary: "",
                                        });
                                        return;
                                      }

                                      // Valid input
                                      setNetSalarErr("");
                                      setErrInde(0);
                                      setData({
                                        ...data,
                                        net_salary: value,
                                      });
                                    }}
                                    // ref={inputRef}
                                    autocomplete="off"
                                    name="net_salary"
                                    value={data.net_salary}
                                    isNumericString
                                    displayType={"input"}
                                    fixedDecimalScale={true}
                                    className="form-control FormalFiledReport"
                                    //  style={{height:"45%"}}

                                    // onChange={handleChange}
                                    // onInput={handleChange}
                                    readOnly={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 0 &&
                                      state.ClientBranchIDs.SUBROLE != 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : state.ClientBranchIDs.SUBROLE ==
                                                0 &&
                                              state.NumberCounts
                                                .EmployeeFormFIll == true
                                            ? false
                                            : state.ClientBranchIDs.SUBROLE ==
                                                  0 &&
                                                state.NumberCounts
                                                  .EmployeeFormFIll == false
                                              ? true
                                              : state.NumberCounts
                                                    .EmployeeFormFIll == true &&
                                                  state.ClientBranchIDs
                                                    .SUBROLE == 1
                                                ? false
                                                : state.NumberCounts.Editable ==
                                                    2
                                                  ? false
                                                  : true
                                    }
                                  />

                                  <p
                                    className="Error"
                                    style={{ marginLeft: "-5px" }}
                                  >
                                    {netslaraer}
                                  </p>
                                </div>
                              </>
                            ) : null}
                          </>
                        </div>
                        <div className="row"></div>
                      </div>

                      <div className="col-12 mt-3">
                        <div>
                          <span
                            style={{
                              color: "#234492",
                              fontWeight: "550",
                              fontSize: "17px",
                            }}
                          >
                            Uniform Details
                          </span>
                        </div>
                        <div className="row">
                          <div className="col-sm-3 mt-3 mb-3">
                            <label className="form-label">
                              Select uniforms
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              isMulti
                              options={uniformOptions}
                              value={uniformOptions.filter((opt) =>
                                selectedUniforms.includes(opt.value),
                              )}
                              onChange={(vals) => {
                                const newKeys = vals
                                  ? vals.map((v) => v.value)
                                  : [];
                                setSelectedUniformsError("");

                                // update selectedUniforms AND clear removed fields from uniforms
                                setSelectedUniforms((prevSelected) => {
                                  const removedKeys = prevSelected.filter(
                                    (key) => !newKeys.includes(key),
                                  );

                                  setUniforms((prev) => {
                                    const updated = { ...prev };
                                    removedKeys.forEach((key) => {
                                      updated[key] = null; // clear size / count
                                    });
                                    return updated;
                                  });
                                  setUniformErrors((prev) => {
                                    const updated = { ...prev };
                                    removedKeys.forEach((key) => {
                                      delete updated[key];
                                    });
                                    return updated;
                                  });

                                  return newKeys;
                                });
                              }}
                              placeholder="Select uniforms"
                              isDisabled={isDisabled}
                              menuPlacement="top"
                            />
                            {selectedUniformsError ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "4px",
                                }}
                              >
                                {selectedUniformsError}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="row">
                          {/* 2) Render fields based on selectedUniforms */}
                          {selectedUniforms.map((key) => {
                            const config = uniformConfig[key];
                            if (!config) return null;

                            // SIZE FIELDS -> Select with sizes[key]
                            if (config.type === "size") {
                              const options = sizes[config.optionsKey] || [];

                              return (
                                <div key={key} className="col-sm-3 mt-3 mb-3">
                                  <label className="form-label" htmlFor={key}>
                                    {config.label}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Select
                                    id={key}
                                    options={options}
                                    value={
                                      options.find(
                                        (opt) => opt.value === uniforms[key],
                                      ) || null
                                    }
                                    onChange={(val) =>
                                      handleSelectChange_selected(key, val)
                                    }
                                    placeholder={`Select ${config.label.toLowerCase()}`}
                                    menuPlacement="top"
                                    isDisabled={isDisabled}
                                  />
                                  {uniformErrors[key] ? (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "12px",
                                        marginTop: "4px",
                                      }}
                                    >
                                      {uniformErrors[key]}
                                    </p>
                                  ) : null}
                                </div>
                              );
                            }

                            // COUNT FIELDS -> number input
                            if (config.type === "count") {
                              return (
                                <div key={key} className="col-sm-3 mb-3 mt-3">
                                  <label className="form-label" htmlFor={key}>
                                    {config.label}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    id={key}
                                    type="number"
                                    min={0}
                                    className="form-control"
                                    value={uniforms[key] ?? ""}
                                    onChange={(e) => {
                                      const val = e.target.value;

                                      // ❗ restrict length to 8
                                      if (val.length > 8) return;

                                      handleInputChange(key, val);
                                    }}
                                    disabled={isDisabled}
                                    placeholder={`Enter ${config.label.toLowerCase()}`}
                                    // 🔹 prevent scroll / zoom from changing the value
                                    onWheel={(e) => {
                                      e.target.blur(); // removes focus so wheel won't change value
                                    }}
                                    // 🔹 prevent 'e', 'E', '+', '-' from being typed
                                    onKeyDown={(e) => {
                                      if (
                                        ["e", "E", "+", "-"].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    required
                                  />
                                  {uniformErrors[key] ? (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "12px",
                                        marginTop: "4px",
                                      }}
                                    >
                                      {uniformErrors[key]}
                                    </p>
                                  ) : null}
                                </div>
                              );
                            }

                            return null;
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  {state.ClientBranchIDs.SUBROLE == 3 ? (
                    <div
                      className="RoleButton"
                      style={{
                        display: "flex",
                        gap: "15px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "0px 15px",

                        marginBottom: "20px",
                      }}
                    >
                      <button
                        class="btn ButtonCSS"
                        style={{ color: "#ffff", background: "#234492" }}
                        onClick={(e) => {
                          HandlePrevious(e);
                        }}
                      >
                        Previous
                      </button>

                      <button
                        class="btn ButtonCSS"
                        style={{ color: "#ffff", background: "#234492" }}
                        onClick={(e) => {
                          HandleNext(e);
                        }}
                      >
                        Save & Continue
                      </button>
                    </div>
                  ) : (
                    <>
                      {state.NumberCounts.EmployeeFormFIll != false &&
                      (state.NumberCounts.Editable == 2 ||
                        state.ClientBranchIDs.SUBROLE == 0 ||
                        state.ClientBranchIDs.SUBROLE == 1) ? (
                        <div
                          className="RoleButton"
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            padding: "0px 15px",

                            marginBottom: "20px",
                          }}
                        >
                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#234492" }}
                            onClick={(e) => {
                              HandlePrevious(e);
                            }}
                          >
                            Previous
                          </button>

                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#234492" }}
                            onClick={(e) => {
                              HandleNext(e);
                            }}
                          >
                            Save & Continue
                          </button>
                        </div>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Joboffer;
